import { jsx } from "react/jsx-runtime";
import { forwardRef, useMemo, createContext } from "react";
import EzRadioGroupMui from "./Implementations/EzRadioGroupMui.es.js";
const RadioGroupThemeContext = createContext({
  color: "primary",
  variant: "filled"
});
const EzRadioGroup = forwardRef(
  ({
    ariaLabel = "radio-button-group",
    children,
    defaultValue,
    gap,
    labelWidth,
    name,
    onChange,
    row,
    theme,
    value
  }, ref) => {
    const providerValue = useMemo(
      () => ({
        color: (theme == null ? void 0 : theme.color) ?? "primary",
        variant: (theme == null ? void 0 : theme.variant) ?? "filled"
      }),
      [theme == null ? void 0 : theme.color, theme == null ? void 0 : theme.variant]
    );
    return /* @__PURE__ */ jsx(RadioGroupThemeContext.Provider, { value: providerValue, children: /* @__PURE__ */ jsx(
      EzRadioGroupMui,
      {
        ref,
        ariaLabel,
        defaultValue,
        gap,
        labelWidth,
        name,
        onChange,
        row,
        value,
        children
      }
    ) });
  }
);
EzRadioGroup.displayName = "EzRadioGroup";
export {
  RadioGroupThemeContext,
  EzRadioGroup as default
};
//# sourceMappingURL=EzRadioGroup.es.js.map
